import React from 'react';
export function ObjectionsSection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-312">
      <div className="max-w-5xl mx-auto" data-id="element-313">
        <div className="text-center mb-12" data-id="element-314">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy leading-tight" data-id="element-315">
            Claridad ante todo
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-316">
          {/* Esto NO es */}
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-navy/5" data-id="element-317">
            <h3 className="text-xl font-bold text-navy mb-6 flex items-center gap-3 uppercase tracking-wider" data-id="element-318">
              <span className="text-cta" data-id="element-319">✕</span> ESTO NO ES...
            </h3>
            <ul className="space-y-5" data-id="element-320">
              <li className="flex items-start gap-3" data-id="element-321">
                <span className="text-cta mt-1 opacity-70" data-id="element-322">✕</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-323">
                  Una dieta estricta
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-324">
                <span className="text-cta mt-1 opacity-70" data-id="element-325">✕</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-326">
                  Un tratamiento médico
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-327">
                <span className="text-cta mt-1 opacity-70" data-id="element-328">✕</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-329">
                  Promesas milagrosas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-330">
                <span className="text-cta mt-1 opacity-70" data-id="element-331">✕</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-332">
                  Contenido alarmista
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-333">
                <span className="text-cta mt-1 opacity-70" data-id="element-334">✕</span>
                <span className="text-navy/80 font-sans text-lg" data-id="element-335">
                  Un sustituto de tu profesional de salud
                </span>
              </li>
            </ul>
          </div>

          {/* Esto SI es */}
          <div className="bg-navy rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-336">
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3 uppercase tracking-wider" data-id="element-337">
              <span className="text-gold" data-id="element-338">✓</span> ESTO SÍ ES...
            </h3>
            <ul className="space-y-5" data-id="element-339">
              <li className="flex items-start gap-3" data-id="element-340">
                <span className="text-gold mt-1" data-id="element-341">✓</span>
                <span className="text-cream/90 font-sans text-lg" data-id="element-342">
                  Un sistema de información claro y accionable
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-343">
                <span className="text-gold mt-1" data-id="element-344">✓</span>
                <span className="text-cream/90 font-sans text-lg" data-id="element-345">
                  Herramientas para supermercado y cocina
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-346">
                <span className="text-gold mt-1" data-id="element-347">✓</span>
                <span className="text-cream/90 font-sans text-lg" data-id="element-348">
                  Ciencia en español simple
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-349">
                <span className="text-gold mt-1" data-id="element-350">✓</span>
                <span className="text-cream/90 font-sans text-lg" data-id="element-351">
                  Plan de 14 días sostenible
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-352">
                <span className="text-gold mt-1" data-id="element-353">✓</span>
                <span className="text-cream/90 font-sans text-lg" data-id="element-354">
                  El complemento informativo que mereces
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}